import { Conversation } from '@quadminds/client-apis/agents';
import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fromConversationToConversationItem } from '../mappers/conversation/conversation';
import ChatService from '../services/chat.service';
import { ConversationItem } from '../types/Conversation/Conversation';

export function useGetConversations(page = 1, pageSize = 50) {
    const queryClient = useQueryClient();
    const userInfo: IAuthMeV2OutputDto | undefined = queryClient.getQueryData(['userInfo']);

    if (userInfo === undefined) {
        console.error('User info is not available');
    }

    const chatService = new ChatService();

    return useQuery<Conversation[], Error, ConversationItem[]>({
        queryFn: () => chatService.getConversations(page, pageSize),
        queryKey: ['conversations', page],
        select: (data: Conversation[]) => {
            return data.map(fromConversationToConversationItem).filter((conversation) => conversation.title !== null);
        },
    });
}

export default useGetConversations;
